import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import ProblemSolution from "../components/ProblemSolution";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import Audience from "../components/Audience";
import Directory from "../components/Directory";
import Resources from "../components/Resources";
import Pricing from "../components/Pricing";
import Testimonials from "../components/Testimonials";
import Faq from "../components/Faq";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function Home() {
    return (
        <div className="bg-background text-foreground min-h-screen">
            <Navbar />
            <main data-testid="home-page">
                <Hero />
                <ProblemSolution />
                <Features />
                <HowItWorks />
                <Audience />
                <Directory mode="teaser" />
                <Resources />
                <Pricing />
                <Testimonials />
                <Faq />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
